module.exports = __webpack_public_path__ + "img/logo.5ffa4b9b.png";